import moment from "moment";
import { pointsConfig } from "../../pointsConfig";

export function missionsTableData(data) {
  const typeOptions = Object.values(pointsConfig.missionCreation.missionTypes);
  const frequencyOptions = Object.values(
    pointsConfig.missionCreation.frequency
  );
  return [
    {
      elements: [
        {
          type: "text",
          value: data?.title || "N/A",
        },
        {
          type: "text",
          value: data?.description || "N/A",
        },
      ],
      value: "",
      width: "md:w-[45%]",
    },
    {
      elements: [
        {
          type: "text",
          value: data?.pointsRewarded
            ? Number(data?.pointsRewarded).toLocaleString()
            : "N/A",
        },
        {
          render: () => {
            return (
              <div className="flex flex-col text-xxxs">
                <span className="text-primary/50">
                  {
                    frequencyOptions.find(
                      (item) => item.code === data?.frequency
                    )?.label
                  }
                </span>
              </div>
            );
          },
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: [
        {
          type: "text",
          value:
            typeOptions.find((option) => option.code === data?.type)?.label ||
            "N/A",
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },

    {
      elements: [
        {
          type: "toggle",
          value: { ...data, dataType: "mission" },
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: [
        {
          type: "text",
          value: moment(data?.createdAt).format("YYYY/MM/DD"),
        },
        {
          type: "title",
          value: moment(data?.createdAt).format("hh:mm A"),
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
  ];
}
